const gl = {
  common: {
    actions: {
      close: 'Pechar',
      accept: 'Aceptar',
      back: 'Atrás',
      continue: 'Continuar',
    },
    errors: {
      title: 'Erro',
      unknown: 'Erro descoñecido.',
    },
    fields: {
      email: 'Correo electrónico',
      firstName: 'Nome',
      lastName: 'Apelidos',
      country: 'País',
      city: 'Cidade',
      postalCode: 'Código postal',
      password: 'Contrasinal',
      confirmPassword: 'Repite o contrasinal',
      companyName: 'Nome da empresa',
      userType: 'Tipo de usuario',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
    },
    userTypes: {
      person: 'Autónomo',
      company: 'Empresa',
      agent: 'Gestor',
    },
  },

  paymentCancelled: {
    title: 'Pagamento cancelado',
    description: 'O proceso de pagamento cancelouse. Se foi un erro, podes tentalo de novo.',
  },

  paymentSuccess: {
    title: 'Pagamento realizado con éxito!',
    descriptionDemo:
      'Xa podes <link>acceder</link> e gozar de todas as vantaxes da nosa plataforma.',
    descriptionStandard:
      'Enviamos un correo electrónico cos detalles da túa subscrición. Por favor, revisa a túa caixa de entrada e segue as instrucións para completar o proceso.',
  },

  registration: {
    title: 'Comezar rexistro',
    titleDemo: 'Comezar rexistro en demo',
    complete: 'Completa',
    stepsCount: '3 pasos',
    toCreateAccount: 'para crear a túa conta',
    planFallback: 'Plan',
    planSelection: 'Selección de plan',
    expensesTotalUsers: 'Total: {{total}} usuarios en Billivo Expenses ({{base}} incluídos no plan)',
    inviteApplied:
      'Invitación da túa xestoría aplicada: 50 € de desconto no plan anual Business Advance + Acceso al Contable.',
    inviteRequiresPlan:
      'A túa xestoría invítate con 50 € de desconto. O desconto aplícase ao plan Business Advance + Acceso al Contable con facturación anual.',

    steps: {
      account: 'Conta',
      userData: 'Datos do usuario',
      addressAndConfirmation: 'Enderezo e confirmación',
      planAndAccount: 'Plan e conta',
    },

    userTypes: {
      person: 'Autónomo',
      company: 'Empresa',
      agent: 'Xestor',
    },

    fields: {
      agentName: 'Nome do xestor',
      agentDocument: 'NIF/CIF/NIE',
      agentVatId: 'VAT ID',
      agentPhoneNumber: 'Número de teléfono',
      agentWebsite: 'Web',
      referralOptIn: 'Queres participar no sistema de referidos de xestor?',
      subscriptionPlan: 'Plan de subscrición',
      billingPeriod: 'Período de facturación',
      expensesPacks: 'Paquetes extra de Billivo Expenses (10 usuarios cada un)',
      userType: 'Tipo de usuario',
      companyName: 'Nome da empresa',
      firstName: 'Nome',
      lastName: 'Apelidos',
      email: 'Correo electrónico',
      password: 'Contrasinal',
      confirmPassword: 'Repite o contrasinal',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      vatId: 'VAT ID',
      phoneNumber: 'Número de teléfono',
      taxType: 'Tipo de imposto',
      addressLine1: 'Liña de enderezo 1',
      addressLine2: 'Liña de enderezo 2',
      postalCode: 'Código postal',
      city: 'Cidade',
      country: 'País',
      discountCode: 'Código de desconto',
      referredByCode: 'Código de referencia',
    },

    billing: {
      monthly: 'Mensual',
      yearly: 'Anual',
      popular: 'Popular',
      save17: 'Aforra 17%',
      monthShort: 'mes',
      yearShort: 'ano',
    },

    taxTypes: {
      peninsula: '01 - Península',
      ceutaMelilla: '02 - Ceuta e Melilla',
      canaryIslands: '03 - Illas Canarias',
      other: '05 - Outros',
    },

    api: {
      devOnly: '⚙️ [SÓ PARA DESENVOLVEDORES]',
      useApi: 'Quero usar a API de Billivo',
      numberingManagement: 'Xestión da numeración',
      selectOption: 'Selecciona unha opción',
      erpOption: 'Quero controlar eu mesmo a numeración das facturas',
      noErpOption: 'Desexo que Billivo xestione a numeración',
    },

    accessibility: {
      showPassword: 'Mostrar contrasinal',
      hidePassword: 'Ocultar contrasinal',
      showConfirmPassword: 'Mostrar confirmación',
      hideConfirmPassword: 'Ocultar confirmación',
    },

    actions: {
      continue: 'Continuar',
      back: 'Atrás',
      sending: 'Enviando...',
      finishRegistration: 'Finalizar rexistro',
      close: 'Pechar',
      accept: 'Aceptar',
    },

    status: {
      sendingInfo: 'Enviando información...',
    },

    errors: {
      title: 'Erro',
      unknown: 'Erro descoñecido.',
      submitUnknown: 'Erro descoñecido ao enviar o formulario',
      stripeLoadFailed: 'Non se puido cargar Stripe.',
      noSession: 'Non hai ningunha sesión á que redirixir',
    },

    validation: {
      invalidWebsite: 'A web non é válida',
      validOption: 'Selecciona unha opción válida',
      apiUsageTypeRequired: 'Selecciona como xestionar a numeración',
      emailRequired: 'O correo electrónico é obrigatorio',
      invalidEmail: 'Correo electrónico non válido',
      companyNameRequired: 'O nome da empresa é obrigatorio',
      firstNameRequired: 'O nome é obrigatorio',
      lastNameRequired: 'Os apelidos son obrigatorios',
      nationalIdRequired: 'NIF/NIE/CIF é obrigatorio',
      invalidDocument: 'Documento non válido',
      invalidCif: 'CIF non válido',
      invalidNifNie: 'NIF/NIE non válido',
      taxTypeRequired: 'O tipo de imposto é obrigatorio',
      phoneRequired: 'O número de teléfono é obrigatorio',
      addressRequired: 'O enderezo é obrigatorio',
      postalCodeRequired: 'O código postal é obrigatorio',
      cityRequired: 'A cidade é obrigatoria',
      countryRequired: 'O país é obrigatorio',
      billingPeriodRequired: 'O período de facturación é obrigatorio',
      passwordRequired: 'O contrasinal é obrigatorio',
      passwordMin: 'Mínimo 8 caracteres',
      confirmPasswordRequired: 'Repite o contrasinal',
      passwordsDoNotMatch: 'Os contrasinais non coinciden',
      maxLength: 'Máximo {{max}} caracteres',
      maxValue: 'Máximo {{max}}',
    },

    terms: {
      acceptPrefix: 'Acepto os',
      linkText: 'termos e condicións',
      title: 'Termos e Condicións',
      sections: {
        general: {
          title: '1. Información xeral e aceptación',
          body: 'Estes termos e condicións regulan o acceso e uso de Billivo.',
        },
        definitions: {
          title: '2. Definicións',
          body: 'Usuario: persoa física que utiliza Billivo. Servizos: funcionalidades ofrecidas a través de Billivo. Contido: calquera información ou material dispoñible en Billivo.',
        },
        scope: {
          title: '3. Obxecto e alcance',
          body: 'Billivo permite aos usuarios acceder aos servizos ofrecidos pola empresa.',
        },
        access: {
          title: '4. Alta e acceso',
          body: 'Pode ser necesario rexistrarse e crear unha conta con datos veraces e actualizados.',
        },
        usage: {
          title: '5. Uso de Billivo',
          body: 'O usuario comprométese a utilizar Billivo de maneira lícita e de boa fe.',
        },
        privacy: {
          title: '6. Privacidade e protección de datos',
          body: 'A recollida e o tratamento de datos persoais réxense pola normativa vixente.',
        },
        communications: {
          title: '7. Comunicacións comerciais e boletíns',
          body: 'Ao aceptar estes termos, o usuario autoriza determinadas comunicacións relacionadas con Billivo.',
        },
        intellectualProperty: {
          title: '8. Propiedade intelectual e industrial',
          body: 'Todos os dereitos sobre Billivo e os seus contidos pertencen á empresa ou a terceiros autorizados.',
        },
        liability: {
          title: '9. Exclusión de garantías e responsabilidade',
          body: 'A empresa non garante a dispoñibilidade continua de Billivo en todos os casos.',
        },
        thirdPartyLinks: {
          title: '10. Ligazóns a sitios de terceiros',
          body: 'Billivo pode incluír ligazóns a sitios de terceiros, sen responsabilizarse do seu contido.',
        },
        modifications: {
          title: '11. Modificación dos Termos',
          body: 'A empresa poderá modificar estes termos cando o considere necesario.',
        },
        termination: {
          title: '12. Terminación',
          body: 'A empresa poderá suspender ou cancelar o acceso en caso de incumprimento ou uso fraudulento.',
        },
        jurisdiction: {
          title: '13. Lei aplicable e xurisdición',
          body: 'Estes termos réxense pola lexislación española.',
        },
        contact: {
          title: '14. Contacto',
          body: 'Para calquera dúbida, o usuario pode contactar coa empresa por correo electrónico.',
        },
      },
    },
  },

  registrationSuccess: {
    title: 'Rexistro realizado con éxito!',
    descriptionDemo:
      'Xa podes <link>acceder</link> e gozar de todas as vantaxes da nosa plataforma.',
    descriptionStandard:
      'Enviamos un correo electrónico cos detalles do teu rexistro. Por favor, revisa a túa caixa de entrada e segue as instrucións para completar o proceso.',

    apiCredentials: {
      title: 'Credenciais de API - IMPORTANTE!',
      warning:
        'Este contrasinal <strong>NON se gardou</strong> e só se mostrará unha vez. Gárdao nun lugar seguro antes de saír desta páxina.',
      emailLabel: 'Correo electrónico:',
      passwordLabel: 'Contrasinal:',
    },

    snackbar: {
      copied: '{{field}} copiado no portapapeis',
      email: 'Correo electrónico',
      password: 'Contrasinal',
    },
  },

  simpleForm: {
    title: 'Rexistro rápido',
    subtitle: 'Completa o formulario e ao finalizar mostrarémosche o teu QR.',
    optional: 'Opcional',
    fields: {
      country: 'País',
      userType: 'Tipo de usuario',
      firstName: 'Nome',
      lastName: 'Apelidos',
      companyName: 'Nome da empresa',
      email: 'Correo electrónico',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      taxId: 'Número de identificación fiscal',
      taxIdOptional: 'Número de identificación fiscal (opcional)',
    },
    userTypes: {
      person: 'Autónomo',
      company: 'Empresa',
    },
    helpers: {
      companyCif: 'Introduce o CIF da empresa',
      personNifNie: 'Introduce o teu NIF ou NIE',
      euRequired: 'Este campo é obrigatorio para clientes da UE',
      outsideEuOptional: 'Podes completalo se dispós de identificación fiscal',
    },
    validation: {
      countryRequired: 'O país é obrigatorio',
      userTypeRequired: 'O tipo de usuario é obrigatorio',
      emailRequired: 'O correo electrónico é obrigatorio',
      invalidEmail: 'Correo electrónico non válido',
      companyNameRequired: 'O nome da compañía é obrigatorio',
      firstNameRequired: 'O nome é obrigatorio',
      lastNameRequired: 'Os apelidos son obrigatorios',
      nationalIdRequiredSpain: 'NIF/NIE/CIF é obrigatorio',
      invalidDocument: 'Documento non válido',
      invalidCif: 'CIF non válido',
      invalidNifNie: 'NIF/NIE non válido',
      taxIdRequired: 'O número de identificación fiscal é obrigatorio',
    },
    actions: {
      register: 'Rexistrarme',
      registering: 'Rexistrando...',
      close: 'Pechar',
      accept: 'Aceptar',
    },
    status: {
      sending: 'Enviando información...',
    },
    errors: {
      title: 'Erro',
      unknownError: 'Erro descoñecido.',
      submitError: 'Erro descoñecido ao enviar o formulario',
    },
    terms: {
      acceptPrefix: 'Acepto os',
      linkText: 'termos e condicións',
      title: 'Termos e Condicións',
      sections: {
        general: {
          title: '1. Información xeral e aceptación',
          body: 'Estes termos e condicións (os "Termos") regulan o acceso e uso da aplicación móbil e/ou web (en diante Billivo) desenvolvida por Code10 IT Consultants S.L. Se non estás de acordo cos Termos, non uses Billivo.',
        },
        definitions: {
          title: '2. Definicións',
          body: 'Usuario: a persoa física que, unha vez aceptados estes Termos, utiliza Billivo independentemente de se actúa en nome propio ou en representación dun terceiro.',
        },
        scope: {
          title: '3. Obxecto e alcance',
          body: 'Billivo permite aos Usuarios acceder aos Servizos ofrecidos pola empresa. O uso de Billivo ten carácter persoal e non comercial.',
        },
        access: {
          title: '4. Alta e acceso',
          body: 'Para utilizar determinados Servizos pode ser necesario rexistrarse e crear unha conta, facilitando datos veraces e actualizados. O Usuario é responsable de custodiar as súas credenciais.',
        },
        usage: {
          title: '5. Uso de Billivo',
          body: 'O Usuario comprométese a utilizar Billivo de maneira lícita, de boa fe e sen contravir o ordenamento xurídico.',
        },
        privacy: {
          title: '6. Privacidade e protección de datos',
          body: 'A recollida e o tratamento de datos persoais réxense pola Política de Privacidade e pola normativa vixente aplicable.',
        },
        communications: {
          title: '7. Comunicacións comerciais e boletíns',
          body: 'Ao aceptar estes Termos e darse de alta en Billivo, o Usuario autoriza expresamente a empresa a utilizar o seu enderezo de correo electrónico e outros datos de contacto para enviarlle comunicacións.',
        },
        intellectualProperty: {
          title: '8. Propiedade intelectual e industrial',
          body: 'Todos os dereitos de propiedade intelectual e industrial sobre Billivo, os seus códigos fonte, deseño, contidos, logotipos e marcas pertencen á empresa ou a terceiros que autorizaron o seu uso.',
        },
        liability: {
          title: '9. Exclusión de garantías e responsabilidade',
          body: 'A empresa non garante a dispoñibilidade, continuidade nin infalibilidade de Billivo e queda exenta de responsabilidade na medida permitida pola lei.',
        },
        thirdPartyLinks: {
          title: '10. Ligazóns a sitios de terceiros',
          body: 'Billivo pode incluír ligazóns a sitios web ou contidos de terceiros. A empresa non controla estes sitios e non é responsable do seu contido.',
        },
        modifications: {
          title: '11. Modificación dos Termos',
          body: 'A empresa poderá modificar estes Termos cando o considere necesario. As modificacións entrarán en vigor desde a súa publicación.',
        },
        termination: {
          title: '12. Terminación',
          body: 'A empresa poderá suspender ou cancelar o acceso do Usuario cando detecte incumprimentos, uso fraudulento ou contrario á lei.',
        },
        jurisdiction: {
          title: '13. Lei aplicable e xurisdición',
          body: 'Estes Termos réxense pola lexislación española. Para a resolución de conflitos, as partes sométense aos xulgados e tribunais competentes.',
        },
        contact: {
          title: '14. Contacto',
          body: 'Para calquera dúbida ou consulta, o Usuario pode poñerse en contacto coa empresa enviando un correo electrónico a support@billivo.com.',
        },
      },
    },
  },

  simpleFormSuccess: {
    notFound: {
      title: 'Non se atopou o rexistro',
      description: 'Non temos información suficiente para mostrar o QR.',
      backButton: 'Volver ao formulario',
    },
    success: {
      title: 'Rexistro realizado con éxito!',
      description:
        'O teu usuario creouse correctamente. Garda este QR e móstrallo ao condutor para que poida emitir a túa factura.',
    },
    temporaryPassword: {
      title: 'Contrasinal temporal',
      description:
        'Este contrasinal xerouse automaticamente e deberá cambiarse no primeiro acceso.',
      emailLabel: 'Correo electrónico:',
      passwordLabel: 'Contrasinal temporal:',
    },
    snackbar: {
      copied: '{{field}} copiado no portapapeis',
      email: 'Correo electrónico',
      temporaryPassword: 'Contrasinal temporal',
    },
  },
};

export default gl;
